// Code generated by Prismic. DO NOT EDIT.

import DropdownPanelCallToAction from "./DropdownPanelCallToAction";
import DropdownPanelColumnLinks from "./DropdownPanelColumnLinks";
import DropdownPanelHeading from "./DropdownPanelHeading";
import MenuItem from "./MenuItem";

export const components = {
	dropdown_panel_call_to_action: DropdownPanelCallToAction,
	dropdown_panel_column_links: DropdownPanelColumnLinks,
	dropdown_panel_heading: DropdownPanelHeading,
	menu_item: MenuItem
};